export const ChangeEffectiveDateScenarioEnum = {
  NoStatusChange_CanSetPastEffectiveDate_ExistingStudent_OnExistingApp: 0,
  NoStatusChange_CanSetPastEffectiveDate_ExistingStudent_AddedToExistingApp: 1,
  NoStatusChange_CanSetPastEffectiveDate_ExistingStudent_AddedToNewApp: 2,
  NoStatusChange_CanSetPastEffectiveDate_NewStudent_AddedToExistingApp: 3,
  NoStatusChange_CanSetPastEffectiveDate_NewStudent_AddedToNewApp: 4,
  NoStatusChange_ExistingStudent_OnExistingApp: 5,
  NoStatusChange_ExistingStudent_AddedToExistingApp: 6,
  NoStatusChange_ExistingStudent_AddedToNewApp: 7,
  NoStatusChange_NewStudent_AddedToExistingApp: 8,
  NoStatusChange_NewStudent_AddedToNewApp: 9,
  BeneficialStatusChange_CanSetPastEffectiveDate: 10,
  BeneficialStatusChange: 11,
  AdverseStatusChange_CanSetPastEffectiveDate: 12,
  AdverseStatusChange: 13,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ChangeEffectiveDateScenarioEnum.js